module.exports = __webpack_public_path__ + "img/arrow-gray.983b89c0.svg";